/**
 * One question every "magic" touch asks first: may this move? False under
 * prefers-reduced-motion, and false where there is no window or no
 * matchMedia (tests, server render), so nothing animates by accident.
 */
export function motionAllowed() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  try {
    return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}

/** Ease-out cubic: fast start, soft landing. t in [0, 1]. */
export const easeOutCubic = (t) => 1 - (1 - t) ** 3;
